import React, { FC, SyntheticEvent } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { useFaqDetails } from "../../context";
import { FaqDetailsTabs } from "../../context/types";
import { StyledTab, StyledTabs } from "./styled";
import useRolePermission from "entities/auth/hooks/useRolePermission";

const Tabs: FC = () => {
  const { selectedTab, setSelectedTab } = useFaqDetails();
  const { allowed: hasReadAccess } = useRolePermission("faq:read");
  const { allowed: hasReadTranslationsAccess } = useRolePermission(
    "faq:translations:read",
  );

  const shouldRenderGeneralTab = hasReadAccess;
  const shouldRenderTranslationsTab = hasReadAccess || hasReadTranslationsAccess;

  const handleTabChange = (_: SyntheticEvent, newTab: FaqDetailsTabs) => {
    setSelectedTab(newTab);
  };

  return (
    <StyledTabs
      value={selectedTab}
      onChange={handleTabChange}
      TabIndicatorProps={{
        style: {
          backgroundColor: COLOR_PRIMARY_MAIN,
          height: 2,
        },
      }}
    >
      {shouldRenderGeneralTab && (
        <StyledTab
          id="page-tab-general"
          aria-controls="module-tabpanel-general"
          value={FaqDetailsTabs.General}
          disableRipple
          label="General"
        />
      )}
      {shouldRenderTranslationsTab && (
        <StyledTab
          id="page-tab-translations"
          aria-controls="module-tabpanel-translations"
          value={FaqDetailsTabs.Translations}
          disableRipple
          label="Translations"
        />
      )}
    </StyledTabs>
  );
};

export default Tabs;
